<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0ZM6.075 5.85a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Zm4.95.9a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0Zm-5.696 6.097c.791-.92 2.127-1.547 3.67-1.547 1.545 0 2.88.627 3.672 1.547a.5.5 0 0 0 .758-.652c-1-1.163-2.625-1.895-4.43-1.895-1.804 0-3.428.732-4.428 1.894a.5.5 0 1 0 .758.653Z"
          fill="currentColor"/>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'SmileySad',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 18 18',
    },
  },
};
</script>

<style scoped>
  
</style>